export default "__VITE_ASSET__fa3c4e8a__"